'use client';

import { Link } from '@coolblue-development/freddy';
import navigateTrigger from '@coolblue-development/ga4-events/triggers/SegmentNavigation/navigateTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';

import type { SegmentNavigation as SegmentNavigationType } from '../../types';

export const Crosslink = ({
  link,
  index,
  totalIndices
}: {
  link: SegmentNavigationType;
  index: number;
  totalIndices: number;
}) => {
  const { trackEvent } = useAnalytics();

  const params = {
    sub_feature: 'cross_links' as const,
    index: index + 1,
    total_indices: totalIndices,
    url: link.url,
    redirect: link.url
  };

  return (
    <Link href={link.url} variant='subtle' onClick={() => trackEvent(navigateTrigger(params))}>
      {link.title}
    </Link>
  );
};
